/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { createStyles, withStyles } from "@material-ui/core/styles";

import Portal from "./portal";
import { ToastMessagePropTypes } from "../admin/billing/lib/types";
import { redesignTheme } from "../theme/theme";

interface AlertPropTypes {
  color: string;
}

const StyledAlert = withStyles(() => {
  return createStyles({
    icon: {
      display: "none",
    },
    message: {
      color: (props: AlertPropTypes) => props.color,
      fontSize: redesignTheme.fontSize[100],
      fontFamily: redesignTheme.fontFamily.interface,
      fontWeight: redesignTheme.fontWeight.normal,
      lineHeight: "1.4",
    },
    action: {
      "& .MuiSvgIcon-root": {
        color: (props: AlertPropTypes) => props.color,
        fontSize: redesignTheme.fontSize[100],
      },
    },
  });
})(MuiAlert);

const StyledSnackbar = withStyles(() => {
  return createStyles({
    root: {
      maxWidth: "500px",
      "& .MuiPaper-root": {
        backgroundColor: (props: { color: string }): string => {
          return props.color;
        },
      },
    },
  });
})(Snackbar);

const alertBackgroundColor = (messagetype): string => {
  switch (messagetype) {
    case "success":
      return redesignTheme.color.green50;
    case "error":
      return redesignTheme.color.red50;
    case "warning":
      return redesignTheme.color.yellow50;
    case "info":
    default:
      return redesignTheme.color.gray50;
  }
};

const alertTextColor = (messageType): string => {
  switch (messageType) {
    case "success":
      return redesignTheme.color.green600;
    case "error":
      return redesignTheme.color.red600;
    case "warning":
      return redesignTheme.color.yellow700;
    case "info":
    default:
      return redesignTheme.color.gray700;
  }
};

const Alert = (props): React.ReactElement => {
  return <StyledAlert elevation={6} variant="filled" {...props} />;
};

const ToastMessage = ({
  children,
  closeToastMessage,
  isOpen,
  messageType,
}: ToastMessagePropTypes): React.ReactElement => {
  const handleClose = (event, reason): void => {
    if (reason === "clickaway") {
      return;
    }
    closeToastMessage();
  };

  return (
    <Portal rootId="react-toast-message">
      <StyledSnackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        color={alertBackgroundColor(messageType)}
        data-testid="toast-message"
        onClose={handleClose}
        open={isOpen}
      >
        <Alert
          color={alertTextColor(messageType)}
          onClose={handleClose}
          severity={messageType}
        >
          {children}
        </Alert>
      </StyledSnackbar>
    </Portal>
  );
};

export default ToastMessage;
